import React, { Component } from 'react';
import Header from '../partials/header';
import Session from '../services/session'
import Footer from '../partials/Footer';
import Banner from '../partials/Banner';
import {Card, CardsList} from '../components/cards';
import RequestBlock from '../partials/RequestBlock';
import c from '../components';
import demoData from '../demoData';
import i from '../imports';
import BasePage from './BasePage';

import Zoom from 'react-reveal/Zoom';
import Fade from 'react-reveal/Fade';

class Home extends Component {

    constructor(props) {
        super(props);

    }
    
    
    render() {
        
        let testimonials = Session.model.data.testimonials;
        let team = Session.model.data.team;

        let destinations = i.Utils.sortByIndex(Session.model.destinationPages);

        return (
            <BasePage data={Session.model.home}>
                <Banner images={Session.getBannerPictures('home')}
                title={Session.model.home.slogan1}
                text={Session.model.home.slogan2}
                /> 
                <Fade>
                    <div style={{marginTop: "2em"}}>
                        <h2>{Session.model.home.destinations}</h2>
                        <CardsList items={destinations} urlBuilder={i.Utils.createDestinationUrl} />               
                        <h2><i.NavLink style={{color: "#FF5563", textDecoration: "none"}} to={i.Utils.locUrl("destinations")}>{Session.model.common.words.find_more}</i.NavLink></h2>
                    </div>
                </Fade>
                <Fade>
                {testimonials.length > 0 ?
                <div styleName='animated fadeIn' style={{ backgroundColor: 'white', animationDuration: '3s' }}>
                    <span>
                        <c.HorizontalLine/>
                        <h2>{Session.model.home.testimonials}</h2>
                        <i.Container>
                            <i.Row>
                                <i.Col>
                                    <i.OnAtMostTablet>
                                        <c.Slider items={testimonials} itemComponent={c.TestimonialItem} slidesToShow={1} className="slick-testimonial" />
                                    </i.OnAtMostTablet>
                                    <i.OnDesktop>
                                        <c.Slider items={testimonials} itemComponent={c.TestimonialItem} slidesToShow={Math.min(testimonials.length, 3)} className={testimonials.length == 2 ? "" : "slick-testimonial"} />
                                    </i.OnDesktop>
                                </i.Col>
                            </i.Row>
                        </i.Container>
                    </span>
                </div>
                    : null
                    
                }
                </Fade>
                <Fade>
                    {team.length > 0 ?
                    <div styleName='animated fadeIn' style={{ backgroundColor: 'white', animationDuration: '3s' }}>
                        <span>
                            <c.HorizontalLine/>
                            <h2>{Session.model.home.ourteam}</h2>
                            <i.Container>
                                <i.Row>
                                    <i.Col>
                                        <i.OnAtMostTablet>
                                            <c.Slider items={team} itemComponent={c.OurTeamItem} slidesToShow={1}/>
                                        </i.OnAtMostTablet>
                                        <i.OnDesktop>
                                            <c.Slider items={team} itemComponent={c.OurTeamItem} slidesToShow={Math.min(team.length, 3)}/>
                                        </i.OnDesktop>
                                    </i.Col>
                                </i.Row>
                            </i.Container>
                        </span>
                        </div>
                        : null
                    }
                    
                </Fade>
            </BasePage>
        );
    }

}

const TheList = ( ) => {
    let result = [];
    for (let i = 0; i < 100; i++ )
    { result.push(
      <p className="App-intro">
      To get started, edit <code>src/App.js</code> and save to reload.
      sdiohdofihdsoih
      dsiofuhosdhf
      </p>);
    }
  
    return ( result );
}

export default Home;


